import { Component, OnInit, Input, EventEmitter, ElementRef, Output } from '@angular/core';
import { UserService } from "../../_services/user.service";

declare var jQuery: any;


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
})
  
export class UserComponent implements OnInit {

  private users: object[];

  constructor(
    private elRef: ElementRef,
    private service: UserService,
  ) { }

  ngOnInit() {
    this.getUsers();
  }
  //list des users
  getUsers() {
    this.service.getUsers().subscribe((response) => {    
      this.users = response.users;
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/user/user.component.ts